import axios from 'axios';

const baseUrl = window.config.API_URL;

const gettingLinkPreview = async (data) =>{
    const token = JSON.parse(localStorage.getItem('user'))?.token;

    // router.post(
    //     "/getLinkData/:name?/",
    //     DashboardController.getLinkData
    //   );
    const userName = data ; 
    const path = `/api/user/getLinkData/${userName}`;
    const url = baseUrl + path
    const response = await axios.post(url)
    return response.data
}

const linkPreviewService = {
    gettingLinkPreview
  };
  
  export default linkPreviewService;